module.exports = __webpack_public_path__ + "img/banner3.4cfd00f3.png";